import keyBy from 'lodash/keyBy'

import { RootState } from 'types'

type State = RootState['reviews']

export default function reduce(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_REVIEWS': {
      const { reviews } = payload
      return { ...state, ...keyBy(reviews, (r) => r.id) }
    }
    case 'RESET_REVIEWS': {
      const { reviews } = payload
      return { ...keyBy(reviews, (r) => r.id) }
    }
    case 'UPSERT_REVIEW': {
      const { review } = payload
      return { ...state, [review.id]: review }
    }
    default:
      return state
  }
}
